import { Component, OnInit, ViewChild, trigger, state, style, transition, animate, } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { ToasterService }  from 'angular2-toaster/angular2-toaster';
import 'rxjs/add/operator/filter';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { LocalUtils } from '../../restricted/restricted.utils';
import { HeaderService } from '../app-header/app.header.service';
import { ErrorsComponent } from '../../errors/errors.component';
import * as EmailValidator from 'email-validator';
import { ngCopy } from 'ng-copy';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './app-breadcrumbs.component.html',
  animations: [
    trigger('breadcrumbsSize', [
      state('smaller', style({
        width: 'calc(100% - 250px)'
      })),
      state('bigger', style({
        width: '100%'
      })),
      transition('bigger <=> smaller', animate('0.2s ease'))
    ])
  ]
})
export class AppBreadcrumbsComponent implements OnInit {

  @BlockUI() blockUI: NgBlockUI;
  breadcrumbs: Array<Object>;
  public language = [];
  public user: any = {};
  public mail: string = '';
  public rota = {
    meeting: false,
    schedule: false,
    recordings: false,
    monitoring: false,
    reports: false,
    meetingroom: false,
    meetingroomRoom: false,
    endpoint: false,
    calendar: false,
    smartroom: false,
    onCalendarConfig: false,
    onCalendarConfigCalendar: false,
    onCalendarConfigEvents: false,
    onCalendarConfigConfig: false,
    onCalendarConfigReport: false,
    onDesk: false,
    onDeskOverview: false,
    onDeskCalendar: false,
    onDeskReport: false
  }
  public state: string = 'bigger';
  sidebarVisible: boolean = false;
  sidebarMinimized: boolean = false;
  colors = LocalUtils.colorsDefault;
  images = LocalUtils.imagesDefault;
  public web: any = '';
  public h323: any = '';
  public h3232: any = '';
  public sip: any = '';
  public skype: any = '';
  public phone: any = '';
  public phone2: any = '';
  public phone3: any = '';
  public phone4: any = '';

  @ViewChild('joinModal') public joinModal:ModalDirective;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private toasterService: ToasterService,
    private errors: ErrorsComponent,
    private localUtils: LocalUtils) {

    this.user = JSON.parse(LocalUtils.decrypt(localStorage.getItem('user')));
    this.router.events.filter(event => event instanceof NavigationEnd).subscribe((event) => {
      this.breadcrumbs = [];
      let currentRoute = this.route.root,
      url = '';
      this.rota.meeting = false;
      this.rota.schedule = false;
      this.rota.recordings = false;
      this.rota.monitoring = false;
      this.rota.reports = false;

      this.rota.meetingroom = false;
      this.rota.endpoint = false;
      this.rota.calendar = false;
      this.rota.smartroom = false;

      this.rota.onCalendarConfig = false;
      this.rota.onCalendarConfigCalendar = false;
      this.rota.onCalendarConfigEvents = false;
      this.rota.onCalendarConfigConfig = false;
      this.rota.onCalendarConfigReport = false;

      this.rota.onDesk = false;
      this.rota.onDeskOverview = false;
      this.rota.onDeskCalendar = false;
      this.rota.onDeskReport = false;

      do {
        const childrenRoutes = currentRoute.children;
        currentRoute = null;
        childrenRoutes.forEach(route => {
          if (route.routeConfig.path == 'meeting') {
            this.rota.meeting = true
          }
          if (route.routeConfig.path == 'schedule') {
            this.rota.schedule = true
            this.rota.meeting = false;
          }
          if (route.routeConfig.path == 'recordings' && this.rota.meeting) {
            this.rota.recordings = true
            this.rota.meeting = false;
          }
          if (route.routeConfig.path == 'reports' && this.rota.meeting) {
            this.rota.reports = true
            this.rota.meeting = false;
          }

          if (route.routeConfig.path == 'meetingroom') {
            this.rota.meetingroom = true
            this.rota.meetingroomRoom = true
          }
          if (route.routeConfig.path == 'endpoint') {
            this.rota.endpoint = true
            this.rota.meetingroomRoom = false
          }
          if (route.routeConfig.path == 'schedule') {
            this.rota.calendar = true
            this.rota.meetingroomRoom = false
          }
          if (route.routeConfig.path == 'smartroom') {
            this.rota.smartroom = true
            this.rota.meetingroomRoom = false
          }
          if (route.routeConfig.path == 'reports' && this.rota.meetingroom) {
            this.rota.reports = true
            this.rota.meetingroomRoom = false
          }

          if (route.routeConfig.path == 'oncalendarconfig') {
            this.rota.onCalendarConfig = true;
            this.rota.onDesk = false;
          }
          if (route.routeConfig.path == 'calendar') {
            this.rota.onCalendarConfig = true;
            this.rota.onCalendarConfigCalendar = true;
          }
          if (route.routeConfig.path == 'events') {
            this.rota.onCalendarConfigEvents = true;
            this.rota.onCalendarConfigCalendar = false;
          }
          if (route.routeConfig.path == 'config') {
            this.rota.onCalendarConfigConfig = true;
            this.rota.onCalendarConfigCalendar = false;
          }
          if (route.routeConfig.path == 'report') {
            this.rota.onCalendarConfigReport = true;
            this.rota.onCalendarConfigCalendar = false;
          }

          if (route.routeConfig.path == 'desk') {
            this.rota.onDesk = true;
          }
          if (route.routeConfig.path == 'overview') {
            this.rota.onDesk = true;
            this.rota.onDeskOverview = true;
          }
          if (route.routeConfig.path == 'calendar') {
            this.rota.onDeskCalendar = true;
            this.rota.onDeskOverview = false;
          }
          if (route.routeConfig.path == 'report') {
            this.rota.onDeskReport = true;
            this.rota.onDeskOverview = false;
          }

          if (route.outlet === 'primary') {
            const routeSnapshot = route.snapshot;
            url += '/' + routeSnapshot.url.map(segment => segment.path).join('/');
            this.breadcrumbs.push({
              label: route.snapshot.data,
              url:   url
            });
            currentRoute = route;
          }
        });
      } while (currentRoute);
    });

    HeaderService.changeRoom.subscribe(r => {
      this.user = JSON.parse(LocalUtils.decrypt(localStorage.getItem('user')));
    });

    HeaderService.changeSubroom.subscribe(r => {
      this.user = r;
    });
  }

  async ngOnInit() {
    this.language = await this.localUtils.getUserLanguage()

    HeaderService.sidebar.subscribe(r => {
      if (r && !this.sidebarMinimized) {
        this.state = 'smaller'
      } else {
        this.state = 'bigger'
      }
    });

    HeaderService.minimized.subscribe(r => {
      if (r) {
        this.state = 'bigger'
        this.sidebarMinimized = true;
      } else {
        this.state = 'smaller'
        this.sidebarMinimized = false;
      }
    });

    HeaderService.breadcrumbsImages.subscribe(r => {
      this.images.meetingImage = r.meeting;
      this.images.meetingImageActive = r.meetingActive;
      this.images.scheduleImage = r.schedule;
      this.images.scheduleImageActive = r.scheduleActive;
      this.images.recordingImage = r.recording;
      this.images.recordingImageActive = r.recordingActive;
      this.images.reportImage = r.report;
      this.images.reportImageActive = r.reportActive;
      this.images.instructionImage = r.instruction;

      this.images.meetingroomImage = r.meeting;
      this.images.meetingroomActive = r.meetingActive;
      this.images.endpointImage = r.schedule;
      this.images.endpointActive = r.scheduleActive;
      this.images.smartroomImage = r.recording;
      this.images.smartroomActive = r.recordingActive;
      this.images.calendarImage = r.report;
      this.images.calendarActive = r.reportActive;
    });

  }

  joinOpen() {
    this.joinModal.show();
  }

  joinMail(){
    return
  }


}



// WEBPACK FOOTER //
// ./src/app/components/app-breadcrumbs/app-breadcrumbs.component.ts